import React, { useState } from "react"
import { useStore } from "../../teafuljs/store"
import { getTranslation } from "../../scripts/getTranslation"
import { getPerBookData } from "../../scripts/getOTNTChartData"
import Card from "@material-ui/core/Card"
import SourceAccordion from "./SourceAccordion"
import CardHeader from "@material-ui/core/CardHeader"
import CardContent from "@material-ui/core/CardContent"
import { Doughnut } from "react-chartjs-2"
import bibleBookList from "../../data/BookChapterList.json"

import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles({
  main: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    textAlign: "center",
    marginBottom: "75px",
    maxHeight: "fit-content",
  },
  card: {
    maxHeight: "800px",
    height: "fit-content",
    margin: "5px",
  },
  leftCard: {
    marginRight: "8px",
  },
  top5: {
    flex: 1,
    textAlign: "center",
    fontSize: "75%",
    padding: 0,
  },
  cardTitle: {
    margin: "0",
    textDecoration: "underline",
    fontWeight: "bold",
    fontSize: "80%",
    padding: "2px",
  },
  top5List: {
    padding: "1px",
    margin: 1,
  },
  cardContent: {
    margin: 0,
    fontSize: "11px",
    lineHeight: "13px",
    position: "relative",
    width: "100%",
    paddingBottom: 1,
  },
  backgroundColor: {
    backgroundColor: "white",
    border: "solid grey 1px",
  },
  red: {
    color: "#d60000",
  },
  green: {
    color: "#006400",
  },
  blue: {
    color: "darkblue",
  },
  topSources: {
    flex: "1 100px",
  },
  topWords: {
    flex: "1 100px",
  },
  colorComparison: {
    flex: "1 1 300px",
    maxHeight: "275px",
  },
  segmentBarChart: {
    flex: "1 1 400px",
    height: "fit-content",
  },
  chartholder: {
    position: "relative",
    width: "100%",
    height: "100%",
    padding: "5px",
    marginBottom: "50px",
  },
  bookChart: {
    height: "500px",
  },
  segChart: {
    height: "800px",
  },
  piechart: {
    height: "300px",
  },
  introSubtitle: {
    color: "rgb(83, 152, 255)",
    fontWeight: "bold",
    textAlign: "center",
  },
  testamentToggle: {
    position: "relative",
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  toggleButton: {
    margin: "10px",
    flex: "0 1 120px",
    fontSize: "40%",
  },
})

// ---------------------- //
// PIE CHART DATA
// ---------------------- //

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  layout: {
    padding: {
      left: 10,
      right: 10,
      top: 0,
      bottom: 0,
    },
  },
  legend: {
    position: "top",
    labels: {
      fontSize: 9,
      boxWidth: 40,
    },
    // display: false
  },
}

const createColorData = (obj, translations, language) => {
  // const labels = Object.keys(obj)
  // labels.pop()
  const values = ["black", "red", "green", "blue"].map(l => obj[l])
  return {
    labels: [
      `${getTranslation(
        translations,
        language,
        "UI",
        "source_narrator"
      )} (${Math.round((values[0] / obj.total) * 100)}%)`,
      `${getTranslation(
        translations,
        language,
        "UI",
        "source_god"
      )} (${Math.round((values[1] / obj.total) * 100)}%)`,
      `${getTranslation(
        translations,
        language,
        "UI",
        "source_lead"
      )} (${Math.round((values[2] / obj.total) * 100)}%)`,
      `${getTranslation(
        translations,
        language,
        "UI",
        "source_other"
      )} (${Math.round((values[3] / obj.total) * 100)}%)`,
    ],
    datasets: [
      {
        data: [values[0], values[1], values[2], values[3]],
        backgroundColor: ["grey", "#ffadad", "#b9f8b9", "rgb(142, 227, 255)"],
        hoverBackgroundColor: ["black", "#d60000", "#006400", "darkblue"],
      },
    ],
    options: {
      direction: language === "ARB" ? "rtl" : "ltr",
    },
  }
}

const SegmentData = ({ colors, sources, alignment }) => {
  const translations = useStore.translations()[0]
  const language = useStore.language()[0]
  const classes = useStyles()

  return (
    <div className={classes.root} style={alignment ? { direction: "rtl" } : {}}>
      <div className={classes.main}>
        <Card
          className={`${classes.backgroundColor} ${classes.card} ${
            classes.colorComparison
          }`}
        >
          <CardHeader
            title={getTranslation(
              translations,
              language,
              "UI",
              "source_role_comparison"
            )}
            disableTypography={true}
            className={classes.cardTitle}
          />
          <CardContent className={`${classes.cardContent} ${classes.chart}`}>
            <Doughnut
              data={createColorData(colors, {translations, language})}
              options={chartOptions}
              height={null}
              width={null}
            />
          </CardContent>
        </Card>
      </div>
      <div className={classes.main}>
        <SourceAccordion sources={sources} />
      </div>
    </div>
  )
}

export default SegmentData